import { BrowserRouter, Navigate, Route, Routes, } from "react-router-dom";
import { UserContextProvider } from "./context";
import Layout from "./components/Layout";
import Home from "./components/Home";
function App() {
  return (
    <BrowserRouter>
      <UserContextProvider>
        <Layout>
          <Home />
        </Layout>
      </UserContextProvider>
    </BrowserRouter >
  );
}

export default App;
